import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class LoginPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNumber: '',

			showOtpSection: false,
			otp: '',

			showSignUpSection: false,
			first_name: '',
			last_name: '',
			email: ''
		};
	}
	componentDidMount() {
		document.getElementById('body').style.paddingTop = '0px';

		let is_guest = JSON.parse(localStorage.getItem('is_guest'));
		if (is_guest === false) this.props.history.replace('/');
	}

	sendOtp = () => {
		let { phoneNumber } = this.state;
		if (phoneNumber.length === 10) {
			this.setState({ showOtpSection: true });
		}
	};
	focusNextField(e, index) {
		let { otp } = this.state;
		let inputVal = e.target.value;
		if (inputVal === '') inputVal = ' ';
		otp = otp.substring(0, index) + inputVal + otp.substring(index + 1, otp.length);
		this.setState({ otp });
		if (index < 5 && (inputVal !== '') & (inputVal !== ' ')) {
			let id = 'index_' + (index + 1);
			document.getElementById(id).focus();
		}
	}
	verifyOtp = () => {
		let { otp, phoneNumber } = this.state;
		let trimmedOtp = otp.replace(/\s/g, '');
		if (trimmedOtp.length === 6 && phoneNumber.length === 10) {
			this.setState({ showOtpSection: false });
			this.setState({ showSignUpSection: true });
		}
	};
	handleChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};
	registerUser = () => {
		let { first_name, last_name, email, phoneNumber } = this.state;
		localStorage.setItem('is_guest', false);
		localStorage.setItem('name', first_name + ' ' + last_name);
		localStorage.setItem('email', email);
		localStorage.setItem('phonenumber', phoneNumber);
		this.props.history.replace('/');
	};
	render() {
		const {
			phoneNumber,
			showOtpSection,
			otp,

			showSignUpSection,
			first_name,
			last_name,
			email
		} = this.state;

		let trimmedOtp = otp.replace(/\s/g, '');

		return (
			<div className="loginPage">
				<div className="plainHeader">
					<Link className="logo" to="/">
						<img src={require('assets/imgs/logo.png')} alt="" className="" />
					</Link>
				</div>

				<div className="container py-5 content">
					<div className="row justify-content-center m-0 py-5 w-100">
						<div className="col-md-8 col-lg-6 px-1 px-sm-3">
							<h1 className="title">Welcome back</h1>
							{!showOtpSection &&
							!showSignUpSection && (
								<React.Fragment>
									<p className="subtitle">Sign in with your mobile number.</p>
									<input
										className="form-control"
										placeholder="Phone number"
										maxLength={10}
										value={phoneNumber}
										onChange={(e) => this.setState({ phoneNumber: e.target.value })}
									/>
									<button
										className="w-100 mt-4"
										onClick={this.sendOtp}
										disabled={phoneNumber.length < 10}
									>
										Next
									</button>
								</React.Fragment>
							)}
							{showOtpSection &&
							!showSignUpSection && (
								<React.Fragment>
									<p className="subtitle">
										Enter 6 digit code sent to your phone +91-{phoneNumber}{' '}
										<span onClick={() => this.setState({ showOtpSection: false })}>( Edit )</span>
									</p>
									<div className="mt-2 d-flex align-items-center flex-wrap">
										<div className="d-flex flex-row otpSection">
											{[ 1, 2, 3, 4, 5, 6 ].map((field, index) => (
												<input
													className="form-control"
													type="tel"
													key={index}
													id={'index_' + index}
													maxLength={1}
													onChange={(e) => this.focusNextField(e, index)}
													autoFocus={index === 0 ? true : false}
												/>
											))}
										</div>
										<button
											className="w-100 mt-4"
											disabled={trimmedOtp.length < 6}
											onClick={this.verifyOtp}
										>
											Next
										</button>
									</div>
								</React.Fragment>
							)}
							{showSignUpSection && (
								<React.Fragment>
									<p className="subtitle">
										+64-{phoneNumber}{' '}
										<span
											onClick={() =>
												this.setState({ showOtpSection: false, showSignUpSection: false })}
										>
											( Edit )
										</span>
									</p>
									<input
										className="form-control my-2"
										placeholder="First Name"
										name="first_name"
										value={first_name}
										onChange={this.handleChange}
									/>
									<input
										className="form-control my-3"
										placeholder="Last Name"
										name="last_name"
										value={last_name}
										onChange={this.handleChange}
									/>
									<input
										className="form-control my-2"
										type="email"
										placeholder="Email"
										name="email"
										value={email}
										onChange={this.handleChange}
									/>

									<button
										className="w-100 mt-3"
										disabled={first_name === '' || last_name === '' || email === ''}
										onClick={this.registerUser}
									>
										Signup
									</button>
								</React.Fragment>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default LoginPage;
